import { INITIALIZE_FORM } from '../actionTypes';
import { resetPasswordUserActions } from '../reducer';

export default (values) => resetPasswordUserActions[INITIALIZE_FORM](values);
